import { render, staticRenderFns } from "./FormContactManageAddress.vue?vue&type=template&id=445ccc48&"
import script from "./FormContactManageAddress.vue?vue&type=script&lang=ts&"
export * from "./FormContactManageAddress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('445ccc48')) {
      api.createRecord('445ccc48', component.options)
    } else {
      api.reload('445ccc48', component.options)
    }
    module.hot.accept("./FormContactManageAddress.vue?vue&type=template&id=445ccc48&", function () {
      api.rerender('445ccc48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ContactData/FormContactManageAddress.vue"
export default component.exports